import script from "./ApplyNote.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyNote.vue?vue&type=script&setup=true&lang=js"

import "./ApplyNote.vue?vue&type=style&index=0&id=74f86252&lang=scss&scoped=true"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f86252"]])

export default __exports__